
import {
    get,
    post,
    del
} from '@/http/request'
import {
    HOST
} from '@/http/config'


// 新增项目申请
export function addProjectApply(params) {
    return post(`${HOST}project-apply/save`, params)
}
// 修改项目申请
export function updateProjectApply(params) {
    return post(`${HOST}project-apply/update`, params)
}
//项目申请列表
export function getProjectApply(params) {
    return get(`${HOST}project-apply/list/`, params)
}
//报头
export function getSysHeader(params) {
    return get(`${HOST}sys-header/list`, params)
}
//获取套红 签发人员
export function documentCategory(params) {
    return get(`${HOST}project-apply/getUserIds`, params)
}
//项目申请草稿箱列表
export function ProjectApplyDraftlist(params) {
    return get(`${HOST}project-apply/draftlist`, params)
}
//项目申请详情
export function ProjectApplyDetial(params) {
    return get(`${HOST}project-apply/get/`, params)
}
// 删除项目申请
export function delProjectApply(params) {
    return del(`${HOST}project-apply/delete`, params)
}


// 历史记录
export function getHistoryList(params) {
    return get(`${HOST}projectApplyHistory/list`, params)
}

// 历史记录详情
export function projectApplyHistoryGet(params) {
    return get(`${HOST}projectApplyHistory/get`, params)
}
// 通过id获取文件信息
export function createWord(id) {
    return get(`${HOST}project-apply/createWord`, { id })
}





// WEBPACK FOOTER //
// ./src/views/ProjectApplication/api/api.js